var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E9CCC98B-0FCA-4903-BA9F-9AA0C5A6432C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,20 C7.553,20 8,20.448 8,21 L8,27 C8,27.552 7.553,28 7,28 L1,28 C0.447,28 0,27.552 0,27 L0,21 C0,20.448 0.447,20 1,20 L7,20 Z M7,10 C7.553,10 8,10.448 8,11 L8,17 C8,17.552 7.553,18 7,18 L1,18 C0.447,18 0,17.552 0,17 L0,11 C0,10.448 0.447,10 1,10 L7,10 Z M17,10 C17.553,10 18,10.448 18,11 L18,17 C18,17.552 17.553,18 17,18 L11,18 C10.447,18 10,17.552 10,17 L10,11 C10,10.448 10.447,10 11,10 L17,10 Z M7,0 C7.553,0 8,0.448 8,1 L8,7 C8,7.552 7.553,8 7,8 L1,8 C0.447,8 0,7.552 0,7 L0,1 C0,0.448 0.447,0 1,0 L7,0 Z M17,0 C17.553,0 18,0.448 18,1 L18,7 C18,7.552 17.553,8 17,8 L11,8 C10.447,8 10,7.552 10,7 L10,1 C10,0.448 10.447,0 11,0 L17,0 Z M27,0 C27.553,0 28,0.448 28,1 L28,7 C28,7.552 27.553,8 27,8 L21,8 C20.447,8 20,7.552 20,7 L20,1 C20,0.448 20.447,0 21,0 L27,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10 C7.553,10 8,10.448 8,11 L8,17 C8,17.552 7.553,18 7,18 L1,18 C0.447,18 0,17.552 0,17 L0,11 C0,10.448 0.447,10 1,10 L7,10 Z M17,10 C17.553,10 18,10.448 18,11 L18,17 C18,17.552 17.553,18 17,18 L11,18 C10.447,18 10,17.552 10,17 L10,11 C10,10.448 10.447,10 11,10 L17,10 Z M17,0 C17.553,0 18,0.448 18,1 L18,7 C18,7.552 17.553,8 17,8 L11,8 C10.447,8 10,7.552 10,7 L10,1 C10,0.448 10.447,0 11,0 L17,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Heatmap/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.000000, -16.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap);
export default __webpack_public_path__ + "static/media/heatMap.01ef33263390cdf786a6f892571e49fc.svg";
export { ForwardRef as ReactComponent };